import $script from 'scriptjs';

import config from 'config';

function ApiError(response) {
    const message = response.error && typeof response.error === 'string' ? response.error : 'Api error';
    const error = new Error(message);
    error.response = response;
    error.type = 'facebookApiError';
    return error;
}

class FacebookAPIAdapter {
    getLoginStatus() {
        return new Promise((resolve, reject) => {
            window.FB.getLoginStatus((response) => {
                if (response) {
                    resolve(response);
                } else {
                    reject(ApiError('Error'));
                }
            });
        });
    }

    api(...args) {
        return new Promise((resolve, reject) => {
            window.FB.api(...args, (response) => {
                if (!response || response.error) {
                    reject(ApiError(response));
                } else {
                    resolve(response);
                }
            });
        });
    }

    login(options) {
        return new Promise((resolve, reject) => {
            window.FB.login((response) => {
                if (response) {
                    resolve(response);
                } else {
                    reject(ApiError(response));
                }
            }, options);
        });
    }
}

const FB_SDK_URL =
    process.env.NODE_ENV === 'production'
        ? 'https://connect.facebook.net/en_US/sdk.js'
        : 'https://connect.facebook.net/en_US/sdk/debug.js';

let instance;

export default () => {
    if (!instance) {
        instance = new Promise((resolve, reject) => {
            $script(FB_SDK_URL, () => {
                if (!window.FB) {
                    const err = new Error('Not initialized');
                    return reject(err);
                }

                window.FB.init({
                    appId: config.facebook_app_id,
                    cookie: true,
                    xfbml: false,
                    status: true,
                    version: 'v12.0',
                });

                const adapter = new FacebookAPIAdapter();

                resolve(adapter);
            });
        });
    }

    return instance;
};
